/* eslint-disable */
/* istanbul ignore file */
import React, { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button as CustomButton } from "../../../../components/Button";
import { connect, type ConnectedProps, useSelector, useDispatch } from "react-redux";
import { type RootState } from "../../../../store";
import { type OperationPermissionState } from "../../../dashboard/redux/operationPermissionSlice";
import { useAuth } from "react-oidc-context";
import { getOperationPermissions } from "../../../dashboard/redux/actionCreator";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import Typography from "@mui/material/Typography";
import LanguageStrings from "../../../../i18n/locales";
import AddAssetDummy from "../../../../assets/AddDevice/image.png";
import Modal from "../../../../components/Modal";
import { Card, Grid, CardContent, CircularProgress, Button } from "@mui/material";
import CustomToast from "../ToastComponent";
import { fetchAssetList } from "../../redux/actionCreator";
import { AssetListState } from "../../redux/assetListSlice";
import { isValidAssetData, inValidStartOfString, inValidEndOfString } from "../../../../utils/validator";
import { APIConfiguration } from "../../../../utils/apiConfiguration";
import { type ImageUploadState } from "../../redux/imageUploadSliceAsset";
import { type ImageUploadPostRequest } from "../../services/imageUploadService";
import { reset } from "../../redux/updateAssetSlice";
import { styled } from "@mui/system";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import InfoVector from "../../../../assets/InfoVector.png";
import FormHelperText from "@mui/material/FormHelperText";
import errorCrossIcon from "../../../../assets/errorCrossIcon.svg";
import { UpdateAssetPutRequest } from "../../services/updateAssetService";
import { fetchAssetCategories, imageUpload } from "../../../gateway-management/redux/actionCreators";
import { downloadImage } from "../../../device-management/redux/actionCreators";
import type { DownloadImageState } from "../../../device-management/redux/downloadImageSlice";
import type { AssetCategoriesState } from "../../../gateway-management/redux/assetCategoriesSliceGateway";
import { UpdateAssetState } from "../../redux/updateAssetSlice";
import { updateAsset } from "../../redux/actionCreator";
import { useLocation } from "react-router-dom";
import AddDeviceDummy from "../../../../assets/AddDeviceDummy/image.png";
import { GenXDropdown } from "../../../../components/GenXDropdown";
import { isOptionDisabled } from "react-select/dist/declarations/src/builtins";
import AuthError from "../../../../components/ErrorComponents/AuthError"
import useRefreshHamburgNotifier from '../../../../customHooks/useRefreshHamburgNotifier'
import "../AddAsset/AddAsset.css";

const httpStatus = APIConfiguration;
const MAX_LENGTH = 100;
const MAX_LENGTH_NAME = 20;
const AddAssetStrings = LanguageStrings().AssetManagementCollectionStrings.AddAssetComponent;
const DashboardStrings = LanguageStrings().Dashboard;

interface LabelValue {
  label: string;
  value: string;
}

const EditAssetComponent = (props: PropsFromRedux): JSX.Element => {
  const location = useLocation();
  const [selectedAsset, setSelectedAsset] = React.useState<LabelValue | null>(null)
  const [existingGateway, setExistingGateway] = React.useState("");
  const [isChecked, setIsChecked] = useState(false);
  const {
    assetId: selectedAssetId,
    gatewayId: selectedGatewayId,
    gatewayName: selectedGatewayName,
    assetName: selectedAssetName,
    assetDescription: selectedAssetDescription,
    parentAssetId: parentAssetId
  } = location.state || {};

  const textStyle = {
    root: {
      backgroundColor: "#272727",
      "& .MuiInputBase-input": {
        color: "#F0F0F0",
        backgroundColor: "#404040",
      },
      "& .MuiInputLabel-root": {
        color: "#F0F0F0",
        "&.Mui-focused": {
          color: "#F0F0F0",
        },
        // Conditional color based on disabled state
        "&.Mui-disabled": {
          color: "#B0B0B0",
        },
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#00000000",
        },
        "&:hover fieldset": {
          borderColor: "#00000000",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#00000000",
        },
      },
      "& .Mui-disabled": {
        color: "#B0B0B0 !important",
      },
    },
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isAssetDetailsEnabled, setIsAssetDetailsEnabled] = React.useState(true);
  const operationPermissions: OperationPermissionState = useSelector(
    (state: RootState) => state.operationPermissions
  );
  const [assetId, setAssetId] = React.useState("");
  const [categoryTypeId, setCategoryTypeId] = React.useState("");
  const [assetName, setAssetName] = React.useState(selectedAssetName);
  const [assetNameErrorInit, setAssetNameErrorInit] = React.useState(false);
  const [assetDescription, setAssetDescription] = React.useState(selectedAssetDescription);
  const [assetDescriptionErrorInit, setAssetDescriptionErrorInit] = React.useState(false);
  const [previewImage, setPreviewImage] = React.useState<any>(AddAssetDummy);
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [showUpdatePopup, setShowUpdatePopup] = React.useState(false);
  const [isStdError, setIsStdError] = React.useState(false);
  const [isCustomError, setIsCustomError] = React.useState(false);
  const [isModbusError, setIsModbusError] = React.useState(false);
  const [assetImage, setAssetImage] = React.useState<any>();
  const [isAssetUpdateInProgress, setIsAssetUpdateInProgress] = React.useState<boolean>(false);
  const [showImagePopup, setShowImagePopup] = React.useState(false)
  const auth = useAuth();
  const assetTypeId = "fdd42da4-4a13-4f57-9e1a-208d95c7f215";
  const gatewayAssetTypeId = "fdd42da4-4a13-4f57-9e1a-208d95c7f213";
  const thermalCategory = "Thermal";
  const { refreshHamburgAction } = useRefreshHamburgNotifier()

  // istanbul ignore next
  React.useEffect(() => {
    (selectedAssetId === '' || selectedAssetId === undefined || selectedAssetId === null) && navigate('/site-list')
    if(selectedGatewayId !== undefined && selectedGatewayId !== null) {
      setIsChecked(true)
      setSelectedAsset({label: selectedGatewayName, value: selectedGatewayId})
    }
  }, [selectedAssetId])

  React.useEffect(() => {
    if (!operationPermissions.updated) {
      props.getOperationPermissions(auth.user?.profile.sub as string);
    }
    props.fetchAssetCategories();
    props.downloadImage(selectedAssetId, assetTypeId, "en_US");
    props.fetchAssetList(parentAssetId, gatewayAssetTypeId, 1, 100, "", "asc", selectedAssetId, "");
  }, []);

  React.useEffect(() => {
    if (
      props.assetCategories?.assetCategories != null &&
      props.assetCategories.assetCategories.length > 0
    ) {
      const thermalCat = props.assetCategories.assetCategories.find(
        (cat: any) => cat.category_type_name === thermalCategory
      );
      if (thermalCat != null) {
        setCategoryTypeId(thermalCat.category_type_id);
      }
    }
  }, [props.assetCategories]);

  React.useEffect(() => {
    if (props?.downloadImageState?.downloadImage?.binaryData !== "") {
      setPreviewImage(props?.downloadImageState?.downloadImage?.binaryData);
      // Prepend the base64 data with the data URI scheme
      //const imageDataUri = `data:image/jpeg;base64,${props.downloadImage.downloadImage?.binaryData}`;
      //setPreviewImage(imageDataUri);
    }
  }, [props?.downloadImageState?.downloadImage?.binaryData]);

  React.useEffect(() => {
    if (props.assetList?.assetList != null && props.assetList.assetList.length > 0) {
      const existingGateway: any = props.assetList.assetList.map(
        (item: any) => {
          return item.name;
        }
      );
      setExistingGateway(existingGateway);
    }
  }, [props.assetList]);

  React.useEffect(() => {
    if (props.updateAssetState.data != null && props.updateAssetState.data.asset_id) {
      setAssetId(props.updateAssetState.data.asset_id)
      refreshHamburgAction('Asset', 'Update')
      if (assetImage) {
        setShowUpdatePopup(false)
        setShowImagePopup(true)
        props.imageUpload({
          assetId: props.updateAssetState.data.asset_id,
          assetTypeId: assetTypeId,
          locale: "en_US",
          file: assetImage,
        });
      }
    }
  }, [props.updateAssetState]);

  React.useEffect(() => {
    if (isChecked) {
      fetchAllAssetList();
    }
  }, [isChecked]);

  const fetchAllAssetList = () => {
    props.fetchAssetList(parentAssetId, gatewayAssetTypeId, 1, 100, "", "asc", "", "");
  };

  const convertToAssetOptions = (assets: any[]): LabelValue[] =>
    assets.map((asset) => ({
      label: asset.name,
      value: asset.id,
    }));

  React.useEffect(() => {
    return () => {
      setAssetId("");
      setCategoryTypeId("");
      setAssetName("");
      setPreviewImage(AddAssetDummy);
      setAssetImage(undefined);
      dispatch(reset());
    };
  }, []);

  function handleBreadCrumbsClick(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void {
    event.preventDefault();
  }

  const handeleCancelClick = (): void => {
    navigate(`/thermal-asset-list/${parentAssetId}`);
  };
  const moveBackOneStep = (): void => {
    setIsAssetDetailsEnabled(true);
  };

  const handleUpdateAsset = (): void => {
    updateAsset();
  };

  const updateAsset = (): void => {
    const postData = {
      type: 'asset',
      id: selectedAssetId,
      name: assetName,
      description: assetDescription,
      asset_type_id: assetTypeId,
      modem_id: selectedAsset ? selectedAsset.value : ''
    };
    props.updateAsset(postData);
  };

  const handleUpdateAssetWithFailure = (): JSX.Element => {
    if (props.updateAssetState.isLoading === false && props.updateAssetState.httpStatus === httpStatus.SUCCESS_HTTP_STATUS) {
      return (
        <Modal buttonTypeNegative='hollow' title={AddAssetStrings.SuccessfullyUpdated} LabelPositive={AddAssetStrings.okay}
          onClickPositive={() => { setShowUpdatePopup(false), handeleCancelClick() }}
          onClose={() => { setShowUpdatePopup(false), handeleCancelClick() }}>
          <p style={{ paddingTop: '1.2em' }}>{AddAssetStrings.AssetHasBeenUpdated}</p>
        </Modal>
      )
    } else if (props.updateAssetState.isLoading) {
      return (
        <Modal title={AddAssetStrings.UpdatingAsset}>
          <div className='CircularprogressAmi'><CircularProgress /></div>
        </Modal>
      )
    } else if (props.updateAssetState.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowUpdatePopup(false) }} onClose={() => { setShowUpdatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.updateAssetState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.updateAssetState.httpStatus === httpStatus.INTERNAL_SERVER_ERROR || props.updateAssetState.httpStatus === httpStatus.CONFLICT_ERROR) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowUpdatePopup(false) }} onClose={() => { setShowUpdatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.updateAssetState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.updateAssetState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError"><AuthError errorMessage="Unauthorized" /></div>
      )
    } else {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowUpdatePopup(false) }}
          onClose={() => { setShowUpdatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {AddAssetStrings.UpdateAssetError} </p>
        </Modal>
      )
    }
  }

  const handleImageWithFailure = (): JSX.Element => {
    if (props.imageUploadState.isLoading === false && props.imageUploadState.httpStatus === httpStatus.CREATED_HTTP_STATUS) {
      return (
        <Modal buttonTypeNegative='hollow' title={AddAssetStrings.SuccessfullyUpdated} LabelPositive={AddAssetStrings.okay}
          onClickPositive={() => { setShowImagePopup(false), handeleCancelClick() }}
          onClose={() => { setShowImagePopup(false), handeleCancelClick() }}>
          <p style={{ paddingTop: '1.2em' }}>{AddAssetStrings.AssetHasBeenCreated}</p>
        </Modal>
      )
    } else if (props.imageUploadState.isLoading) {
      return (
        <Modal title={AddAssetStrings.UpdatingAsset}>
          <div className='CircularprogressAmi'><CircularProgress /></div>
        </Modal>
      )
    } else if (props.imageUploadState.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }} onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.imageUploadState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.imageUploadState.httpStatus === httpStatus.INTERNAL_SERVER_ERROR || props.imageUploadState.httpStatus === httpStatus.CONFLICT_ERROR) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }} onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.imageUploadState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.imageUploadState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError"><AuthError errorMessage="Unauthorized" /></div>
      )
    } else {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }}
          onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {AddAssetStrings.UpdateAssetError} </p>
        </Modal>
      )
    }
  }

  const assetNameErrorMessage = (): string | null => {
    if (assetName?.length > MAX_LENGTH_NAME || !isValidAssetData(assetName)) {
      if (assetName?.length > MAX_LENGTH_NAME) {
        return AddAssetStrings.AssetNameLengthError
      } else if (inValidStartOfString(assetName) || inValidEndOfString(assetName)) {
        return AddAssetStrings.NotAllowedError
      } else if (!isValidAssetData(assetName)) {
        return AddAssetStrings.AssetNameError
      }
    }
    return null
  }
  const assetDescErrorMessage = (): string | null => {
    if (assetDescription?.length > MAX_LENGTH || !isValidAssetData(assetDescription)) {
      if (assetDescription?.length > MAX_LENGTH) {
        return AddAssetStrings.AssetDescLengthError
      } else if (inValidStartOfString(assetDescription) || inValidEndOfString(assetDescription)) {
        return AddAssetStrings.NotAllowedError
      } else if (!isValidAssetData(assetDescription)) {
        return AddAssetStrings.AssetDescriptionError
      }
    }
    return null
  }

  const isAssetNameNotValid = (): boolean => {
    return !isValidAssetData(assetName) || assetName.length > MAX_LENGTH_NAME;
  };
  const isAssetDescriptionNotValid = (): boolean => {
    return (
      !isValidAssetData(assetDescription) || assetDescription.length > MAX_LENGTH
    );
  };

  const shouldDisableNextButton = (): boolean => {
    return isAssetNameNotValid() || isAssetDescriptionNotValid();
  };
  const shouldDisableAddButton = (): boolean => {
    return isStdError || isCustomError || isModbusError;
  };

  const infoCardStyles = {
    height: "515px",
    borderRadius: "10px",
    border: "1px solid #101010",
    backgroundColor: "#272727",
    boxShadow: "1px 1px 1px 0px rgba(0, 0, 0, 0.15)",
    marginTop: "24px",
  };

  const FileInput = styled("input")({
    display: "none",
  });

  const [imageDimensions, setImageDimensions] = useState({
    width: "136px",
    height: "136px",
  });

  const CustomCardContent = styled(CardContent)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "309px",
    height: "240px",
    borderRadius: "10px",
    border: "1px solid var(--General-Secondary, #303030)",
    background: "var(--General-Secondary, #303030)",
    position: "relative",
  });

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const files = event.target.files;
    const maxSize = 100 * 1024;
    const allowedTypes = ["image/jpeg", "image/png"];
    const alphanumericRegex = /^[a-zA-Z0-9]+$/;
    // istanbul ignore else
    if (files !== null && files.length > 0) {
      // Validate file size
      if (files[0].size > maxSize) {
        CustomToast({
          type: "error",
          heading: "Invalid Image Size",
          message: "Image size should be less than 100 KB.",
        });
        setPreviewImage(AddAssetDummy);
        event.target.value = ""; // Clearing the file input value
        return;
      }
      // Validate file type
      if (!allowedTypes.includes(files[0].type)) {
        CustomToast({
          type: "error",
          heading: "Invalid Image Type",
          message: "Only JPEG and PNG image types are allowed.",
        });
        setPreviewImage(AddAssetDummy);
        event.target.value = ""; // Clearing the file input value
        return;
      }
      // Validate file name (without extension)
      const fileNameWithoutExtension = files[0].name.split(".")[0];
      /* istanbul ignore next */
      if (!alphanumericRegex.test(fileNameWithoutExtension)) {
        CustomToast({
          type: "error",
          heading: "Invalid File Name",
          message: "File name should contain only alphanumeric characters.",
        });
        setPreviewImage(AddAssetDummy);
        event.target.value = ""; // Clearing the file input value
        return;
      }
      /* istanbul ignore next */
      if (fileNameWithoutExtension.length > 20) {
        CustomToast({
          type: "error",
          heading: "Invalid File Name",
          message: "File Name is greater than 20 alphanumeric characters.",
        });
        setPreviewImage(AddAssetDummy);
        event.target.value = ""; // Clearing the file input value
        return;
      }
      const reader = new FileReader();
      // istanbul ignore next
      reader.onloadend = () => {
        const image = new Image();
        image.src = reader.result as string;
        image.onload = () => {
          setImageDimensions({ width: "260px", height: "215px" }); // width: 309, height: 240
        };
        setPreviewImage(reader.result as string);
        setAssetImage(files[0]);
      };
      reader.readAsDataURL(files[0]);
    }
  };

  const handleBrowseClick = (): void => {
    fileInputRef.current?.click();
  };

  const FileButton = styled(Button)({
    width: "309px",
    padding: "6px 24px",
    marginTop: "5px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "4px",
    border:
      "1.5px solid var(--component-light-buttons-regular-primary-outline-blue-a-20071-b-3, #64C3FF)",
    background: "#202020",
    boxShadow: "1px 1px 1px 0px rgba(0, 0, 0, 0.30)",
  });

  return (
    <div>
      <div
        role="presentation"
        data-testid="breadcrumbs"
        onClick={handleBreadCrumbsClick}
        className="AmiHeading"
      >
        <ArrowBackIos
          className="assetmgmtli"
          data-testid="breadcrumb-arrow-back"
          aria-label="navArrow"
          sx={{ marginTop: "10px" }}
          onClick={() => {
            navigate(-1);
          }}
        />
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            color: "#f0f0f0",
            fontSize: "12px",
            marginBottom: "14px",
            fontFamily: "Honeywell Sans Web",
            marginTop: "12px",
          }}
        >
          <Link
            aria-label="navBreadcrumb1"
            className="assetmgmtli"
            data-testid="bc-link-1"
            underline="none"
            color="inherit"
            onClick={() => {
              navigate("/thermal-dashboard");
            }}
          >
            {DashboardStrings.HOME}
          </Link>
          <Link
            aria-label="navBreadcrumb2"
            className="assetmgmtli"
            data-testid="bc-link-2"
            underline="none"
            color="inherit"
            onClick={() => {
              navigate("/site-list");
            }}
          >
            {DashboardStrings.SiteManagement}
          </Link>
          <Link
            aria-label="navBreadcrumb3"
            className="assetmgmtli"
            data-testid="bc-link-3"
            underline="none"
            color="inherit"
            onClick={() => {
              navigate(`/thermal-asset-list/${parentAssetId}`);
            }}
          >
            {DashboardStrings.AssetManagement}
          </Link>
          <Typography
            color="inherit"
            sx={{ fontSize: "12px", fontFamily: "Honeywell Sans Web" }}
          >
            {DashboardStrings.EditAsset}
          </Typography>
        </Breadcrumbs>
      </div>
      <div className="ArrowAssetAdd">
        <div>
          <span
            data-testid="assetHistoryDetails"
            className="assetMgtAssetlist"
            style={{
              fontSize: "20px",
              fontWeight: "900",
              fontStyle: "normal",
              lineHeight: "32px",
            }}
          >
            {AddAssetStrings.EditAsset}
          </span>
        </div>
      </div>
      <div>
        <Card sx={infoCardStyles}>
          <CardContent>
            <div className="asset-info-content">
              <p className="asset-info-heading">Asset Info</p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "10px",
              }}
            >
              <div
                className="image-section"
                style={{
                  backgroundColor: "#202020",
                  marginRight: "20px",
                  padding: "20px",
                }}
              >
                <CustomCardContent>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {previewImage?.includes("data:") === true ? (
                      <img
                        src={previewImage}
                        alt="Preview"
                        style={{
                          width: imageDimensions.width,
                          height: imageDimensions.height,
                        }}
                      />
                    ) : previewImage ? (
                      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                      <img
                        src={`data:image/jpeg;base64,${previewImage}`}
                        alt="Preview"
                        style={{ width: "260px", height: "215px" }}
                      />
                    ) : (
                      <img
                        src={AddDeviceDummy}
                        alt="Preview"
                        style={{ width: "136px", height: "136px" }}
                      />
                    )}
                  </div>
                  <FileInput
                    ref={fileInputRef}
                    type="file"
                    id="fileInput"
                    data-testid="browse-image-file"
                    accept="image/jpeg, image/png"
                    onChange={handleFileChange}
                  />
                </CustomCardContent>
                <FileButton
                  data-testid="browse-image-button"
                  onClick={handleBrowseClick}
                  style={{
                    fontFamily: "Honeywell Sans Web",
                    textTransform: "unset",
                  }}
                >
                  Add Photo
                </FileButton>
              </div>
              <div className="info-section" style={{ width: "100%" }}>
                <Grid container spacing={2} style={{ height: "135px" }}>
                  <Grid item md={4}>
                    <span
                      style={{
                        fontSize: "15px",
                        padding: "10px 3px",
                        display: "block",
                        color: "#F0F0F0",
                      }}
                    >
                      Asset Name
                      <sup
                        style={{
                          color: "#B0B0B0",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "24px",
                        }}
                      >
                        *
                      </sup>
                      <Tooltip title="Enter Asset Name with maximum 20 characters. Only space,_,- are allowed." placement="right" arrow>
                        <IconButton size="small">
                          <img
                            style={{
                              width: "12px",
                              height: "12px",
                              marginLeft: "5px",
                            }}
                            src={InfoVector}
                          />
                        </IconButton>
                      </Tooltip>
                    </span>
                    <TextField
                      id="custom-textfield-asset-name"
                      variant="outlined"
                      data-testId="asset-name"
                      placeholder="Enter Asset Name"
                      InputLabelProps={{
                        disabled: true,
                      }}
                      value={assetName}
                      disabled={false}
                      onChange={(e) => {
                        setAssetName(e.target.value);
                        setAssetNameErrorInit(true);
                      }}
                      size="small"
                      autoComplete="off"
                      className={`custom-textfield ${isAssetNameNotValid() && assetNameErrorInit ? "error" : ""}`}
                      sx={{
                        ...textStyle.root,
                        width: "410px",
                      }}
                    />
                    {isAssetNameNotValid() && assetNameErrorInit && (
                      // istanbul ignore next
                      <div style={{ display: "flex" }}>
                        <div style={{ marginTop: "3px" }}>
                          <img src={errorCrossIcon} alt="Error" />
                        </div>
                        <FormHelperText
                          sx={{
                            color: "#EE3426",
                            paddingLeft: "5px",
                            width: "82%",
                          }}
                          className="error-msg"
                        >
                          {assetNameErrorMessage()}
                        </FormHelperText>
                      </div>
                    )}
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ height: "135px" }}>
                  <Grid item md={4}>
                    <span
                      style={{
                        fontSize: "15px",
                        padding: "10px 3px",
                        display: "block",
                        color: "#F0F0F0",
                      }}
                    >
                      Description
                      <sup
                        style={{
                          color: "#B0B0B0",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "24px",
                        }}
                      >
                        *
                      </sup>
                      <Tooltip title="Enter Asset Description with maximum 100 characters. Only space,_,- are allowed." placement="right" arrow>
                        <IconButton size="small">
                          <img
                            style={{
                              width: "12px",
                              height: "12px",
                              marginLeft: "5px",
                            }}
                            src={InfoVector}
                          />
                        </IconButton>
                      </Tooltip>
                    </span>
                    <TextField
                      id="custom-textfield-asset-description"
                      variant="outlined"
                      data-testId="asset-details"
                      placeholder="Enter Asset Details"
                      InputLabelProps={{
                        disabled: true,
                      }}
                      disabled={false}
                      value={assetDescription}
                      onChange={(e) => {
                        setAssetDescription(e.target.value);
                        setAssetDescriptionErrorInit(true);
                      }}
                      size="small"
                      autoComplete="off"
                      className={`custom-textfield ${
                        isAssetDescriptionNotValid() &&
                        assetDescriptionErrorInit
                          ? "error"
                          : ""
                      }`}
                      sx={{
                        ...textStyle.root,
                        width: "410px",
                      }}
                    />
                    {isAssetDescriptionNotValid() &&
                      assetDescriptionErrorInit && (
                        // istanbul ignore next
                        <div style={{ display: "flex" }}>
                          <div style={{ marginTop: "3px" }}>
                            <img src={errorCrossIcon} alt="Error" />
                          </div>
                          <FormHelperText
                            sx={{
                              color: "#EE3426",
                              paddingLeft: "5px",
                              width: "82%",
                            }}
                            className="error-msg"
                          >
                            {assetDescErrorMessage()}
                          </FormHelperText>
                        </div>
                      )}
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ height: "135px" }}>
                  <Grid item md={3}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "80.2%",
                        height: "30.2%",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(event) => setIsChecked(event.target.checked)}
                        style={{width: "22px", height: "22px"}}
                      />
                      <span
                        style={{
                          fontSize: "16px",
                          marginLeft: "12px",
                          color: "#F0F0F0",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {AddAssetStrings.GatewayDropDownHeader}
                      </span>
                    </div>
                    {isChecked && (
                      <>
                        <span
                          style={{
                            fontSize: "15px",
                            padding: "10px 3px",
                            display: "block",
                            color: "#F0F0F0",
                          }}
                        >
                          {AddAssetStrings.GatewayDropDownHeader}
                        </span>
                        <GenXDropdown
                          width={475}
                          value={
                            isChecked ? selectedAsset: null
                          }
                          options={
                            props.assetList.assetList ? convertToAssetOptions(props.assetList.assetList) : []
                          }
                          placeholder="Select a gateway"
                          onSelect={(selectedValue, index) => {
                            // handle the selected value and index here
                            setSelectedAsset(selectedValue);
                          }}
                          data-testId="gateway-dropdown"
                        />
                      </>
                    )}
                  </Grid>
                </Grid>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <div
        style={{
          height: "80px",
          backgroundColor: "#272727",
          margin: "50px 0 10px 0",
          borderRadius: 10,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 1em",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {isAssetDetailsEnabled ? (
            <>
              <CustomButton
                className="AddAssetCancelButton"
                data-testid="cancel-btn-click"
                onClick={() => {
                  handeleCancelClick();
                }}
              >
                {AddAssetStrings.Cancel}
              </CustomButton>
              <CustomButton
                className={`${shouldDisableNextButton() ? "btn-disabled" : ""}`}
                onClick={() => {
                  setShowConfirmation(true)
                }}
                disabled={shouldDisableNextButton()}
              >
                {AddAssetStrings.Update}
              </CustomButton>
            </>
          ) : (
            <>
              <CustomButton
                dataTestId="back-btn"
                className="AddAssetCancelButton"
                onClick={moveBackOneStep}
              >
                {AddAssetStrings.Back}
              </CustomButton>
              <CustomButton
                className={
                  /* istanbul ignore next */
                  `${shouldDisableAddButton() ? "btn-disabled" : ""}`
                }
                dataTestId="add-asset-btn"
                onClick={() => {
                  setShowConfirmation(true);
                }}
                disabled={shouldDisableAddButton()}
              >
                {AddAssetStrings.AddAsset}
              </CustomButton>
            </>
          )}
        </div>
      </div>
      {showConfirmation && (
        <Modal
          buttonTypeNegative="hollow"
          title={AddAssetStrings.UpdateAsset}
          LabelNegative={AddAssetStrings.Cancel}
          LabelPositive={AddAssetStrings.Confirm}
          onClickPositive={() => {
            setShowConfirmation(false), setShowUpdatePopup(true), handleUpdateAsset()
          }}
          onClose={() => {
            setShowConfirmation(false);
          }}
          onClickNegative={() => {
            setShowConfirmation(false);
          }}
        >
          <p style={{ paddingTop: "1.2em" }}>
            {AddAssetStrings.AssetUpdateConfirmation}
          </p>
        </Modal>
      )}
      {
        showUpdatePopup && handleUpdateAssetWithFailure()
      }
      {
        showImagePopup && handleImageWithFailure()
      }
    </div>
  );
};

interface DispatchToProps {
  fetchAssetList: (
    siteId: string,
    assetTypeId: string,
    PageNumber: number,
    PageItems: number,
    searchKey: string,
    SortParams: string,
    parentAssetId: String,
    sortField: string
  ) => void;
  fetchAssetCategories: () => void;
  getOperationPermissions: (sub: string) => void;
  updateAsset: (updateAssetPostRequest: UpdateAssetPutRequest) => void;
  downloadImage: (assetId: string, assetTypeId: string, locale: string) => void;
  imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => void;
}

const mapDispatchToProps = (dispatch: any): DispatchToProps =>
  ({
    fetchAssetList: (
      siteId: string,
      assetTypeId: string,
      PageNumber: number,
      PageItems: number,
      searchKey: string,
      SortParams: string,
      parentAssetId: string,
      sortField: string
    ) =>
      dispatch(
        fetchAssetList(
          siteId,
          assetTypeId,
          PageNumber,
          PageItems,
          searchKey,
          SortParams,
          parentAssetId,
          ""
        )
      ),
    fetchAssetCategories: () => dispatch(fetchAssetCategories()),
    getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub)),
    downloadImage: (assetId: string, assetTypeId: string, locale: string) => dispatch(downloadImage(assetId, assetTypeId, locale)),
    imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => dispatch(imageUpload(imageUploadPostRequest)),
    updateAsset: (updateAssetPutRequest: UpdateAssetPutRequest) => dispatch(updateAsset(updateAssetPutRequest)),
  } as DispatchToProps);

interface StateToProps {
  assetList: AssetListState;
  assetCategories: AssetCategoriesState;
  updateAssetState: UpdateAssetState;
  downloadImageState: DownloadImageState;
  imageUploadState: ImageUploadState;
}

const mapStateToProps = (state: RootState): StateToProps => ({
  assetList: state.assetManagementAssetList,
  assetCategories: state.gatewayManagementAssetCategories,
  updateAssetState: state.updateAssetState,
  downloadImageState: state.downloadImageState,
  imageUploadState: state.imageUploadStateAsset,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(EditAssetComponent);
